import { render, staticRenderFns } from "./myBanji.vue?vue&type=template&id=469f1978&scoped=true"
import script from "./myBanji.vue?vue&type=script&lang=js"
export * from "./myBanji.vue?vue&type=script&lang=js"
import style0 from "./myBanji.vue?vue&type=style&index=0&id=469f1978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469f1978",
  null
  
)

export default component.exports